import Container from "components/Grid/Container";
import SEO from "components/SEO/SEO";
// import { useMap } from 'react-leaflet';
import MapView from "../components/Layout/MapView/MapView";
import MapSidebar from "../components/Layout/MapView/Sidebar/MapSidebar";
import { useEffect, useState } from "react";
import useSidebar from "components/Layout/MapView/Sidebar/useSidebar";
import SidebarButton from "components/Layout/MapView/Sidebar/SidebarButton";
import { useDavidApi } from 'utility/DavidApi/DavidApi';
import { AuthenticatedTemplate } from '@azure/msal-react';
import LoadingOverlay from "../components/Layout/MapView/LoadingOverlay/LoadingOverlay";
// import { cutStepDetails } from "components/Layout/MapView/cutStepDetails";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

function Home() {
    const api = useDavidApi();

    const initialState = {
        incomplete: true
    }
    const [inputs, setInputs] = useState(initialState);
    const [cuts, setCuts] = useState(null);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState('Viewing All Cuts');
    const {isOpen, toggleSidebar} = useSidebar();
    const [centerCoordinates, setCenterCoordinates] = useState([37.977432, -87.544054]);
    const [newZoom, setNewZoom] = useState(11);
    const [subtitle, setSubtitle] = useState('');
    const [sidebarFilterSubmitted, setSidebarFilterSubmitted] = useState(false);
    // const [clientSelectState, setClientSelectState] = useState(false);

    useEffect(() => {
        refreshCuts();

        (async () => {
            await api.getClients();
            await api.getProducts();
        })();
    }, []);

    const handleFilterSubmit = (e = null, resetState = false) => {
        setLoading(true);

        if (e) {
            e.preventDefault();
        }

        let productType = 'All';
        if (inputs["product.id"] === '1'){
            productType = "Asphalt";
        } else if (inputs["product.id"] === '2'){
            productType = "Concrete";
        } else if (inputs["product.id"] === '3') {
            productType = "Additional Work";
        }

        let step = '';
        if (inputs.step !== undefined) {
            step = 'on the ' + inputs.step + ' Step';
        }

        let forClientName = '';

        //handles error from CutLegendControl
        if (inputs["project.client"]) {
            if (inputs["project.client"] !== '' ) {
                const selectedClientId = inputs["project.client"];
                const selectedClient = api.clients?.find(client => client.id === parseInt(selectedClientId));
                if (selectedClient) {
                    forClientName = ' for ' + selectedClient.name; //sets client name in title if filtered in sidebar
                }
        }}

        setTitle('Viewing ' + productType + ' Cuts ' + step + forClientName);
        refreshCuts(resetState);

        if (resetState === true) {
            setTitle('Viewing All Cuts');
            // setNewZoom(12);
        }
    }

    const refreshCuts = (resetState = false) => {
        (async () => {
            let response = [];

            if (resetState) {
                response = await api.searchAllCuts(initialState);
            } else {
                response = await api.searchAllCuts(inputs);
            }

            const filteredCuts = response.filter(cut => {
                const cutDate = new Date(cut?.project?.orderDate);
                const oneYearAgo = new Date();
                oneYearAgo.setDate(oneYearAgo.getDate() - 365);

                // const thirtyDaysAgo = new Date();
                // thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

                const olderThanOneYear = cutDate < oneYearAgo;
                // const olderThan30Days = cutDate < thirtyDaysAgo;
                // const isComplete = cut.steps.length === 5;

                if (olderThanOneYear) {
                    return false;
                } else {
                    return true;
                }

            })

            setCuts(filteredCuts);

            if (filteredCuts?.length === 0) {
                setSubtitle("There are no cuts that match your search.")
            } else {
                setSubtitle('');
            }

            setLoading(false);
        })();
    }

    useEffect(() => {
        if (cuts?.length) {
            const latitudesAndLongitudes = cuts.map(cut => ({
                latitude: parseFloat(cut.latitude),
                longitude: parseFloat(cut.longitude)
            }));

            if (latitudesAndLongitudes?.length > 10) {
                setNewZoom(11);
            } else if (latitudesAndLongitudes?.length >= 5 && latitudesAndLongitudes?.length <= 10) {
                setNewZoom(13);
            }

            const sumLatitudes = latitudesAndLongitudes.reduce((sum, point) => sum + point.latitude, 0);
            const sumLongitudes = latitudesAndLongitudes.reduce((sum, point) => sum + point.longitude, 0);
            const avgLatitude = sumLatitudes / latitudesAndLongitudes.length;
            const avgLongitude = sumLongitudes / latitudesAndLongitudes.length;
            const centerPoint = [avgLatitude, avgLongitude];

            setCenterCoordinates(centerPoint);
        } else if (cuts?.length === 0) {
            setNewZoom(12);
            setCenterCoordinates([37.977432, -87.544054]);
        }

    }, [cuts]);

    return (
        <>
            <AuthenticatedTemplate>
                <SEO title="Home" />
                {loading && (
                    <LoadingOverlay />
                )}
                <Container style={{ margin:"0 auto", height:'calc(100vh - 70px)', width:'100%', padding:"0", display: 'flex' }}>

                    <div className="leaflet-top leaflet-left">
                        <SidebarButton
                            className="leaflet-control"
                            onClick={toggleSidebar}
                            iconLeft={<FontAwesomeIcon icon={solid('bars-filter')} />}
                        >
                            Filter Results
                        </SidebarButton>
                    </div>

                    <div style={{ display: isOpen ? 'block' : 'none' }}>
                        <MapSidebar
                            initialState={initialState}
                            handleFilterSubmit={handleFilterSubmit}
                            cuts={cuts}
                            inputs={inputs}
                            setInputs={setInputs}
                            setLoading={setLoading}
                            refreshCuts={refreshCuts}
                            hide={toggleSidebar}
                            setSidebarFilterSubmitted={setSidebarFilterSubmitted}
                            // clientSelectState={clientSelectState}
                            // setClientSelectState={setClientSelectState}
                        />
                    </div>

                    <MapView
                        cuts={cuts}
                        initialState={initialState}
                        refreshCuts={refreshCuts}
                        loading={loading}
                        setLoading={setLoading}
                        title={title}
                        subtitle={subtitle}
                        handleFilterSubmit={handleFilterSubmit}
                        inputs={inputs}
                        setInputs={setInputs}
                        centerCoordinates={centerCoordinates}
                        newZoom={newZoom}
                        sidebarFilterSubmitted={sidebarFilterSubmitted}
                        setSidebarFilterSubmitted={setSidebarFilterSubmitted}
                     />
                </Container>
            </AuthenticatedTemplate>
        </>
    );
}

export default Home;
